import { render } from "./SocialsConfig.vue?vue&type=template&id=4a4d84e3&scoped=true"
import script from "./SocialsConfig.vue?vue&type=script&lang=js"
export * from "./SocialsConfig.vue?vue&type=script&lang=js"

import "./SocialsConfig.vue?vue&type=style&index=0&id=4a4d84e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4d84e3"]])

export default __exports__